import {responseHasErrors, responseHasData} from '@gl/lit/utils/exports.js';
import {exportService} from '@gl/lit/services/exports.js';
import {convertToDatetimeLocalInputValue} from '@gl/lit/utils/dates.js';
import type {AudienceExportActivity} from '@gl/lit/types/audience_exports.js';
import type {ExportRunLog} from '@gl/lit/types/audience_exports.js';
import type {ExportErrorLogsResponse} from '@gl/lit/types/audience_exports.js';

export const fetchAudienceExportRunLogs = async (
  activity: AudienceExportActivity,
  activityId: string | number
) => {
  const id = activityId;
  const type = 'audience';
  const exportRunId = activity?.export_id.raw ?? '';
  const errorFileUri = activity?.error_file_uri;

  const url = exportService.buildExportLogsUrl({id, type});

  const response: ExportErrorLogsResponse =
    await exportService.getExportRunLogsByUrl(url, exportRunId, errorFileUri);

  if (responseHasErrors(response)) throw response;

  if (responseHasData(response)) {
    return response.data.map((log: ExportRunLog) => {
      return {
        timestamp: log.timestamp
          ? convertToDatetimeLocalInputValue(log.timestamp)
          : 'N/A',
        message: log.event,
      };
    });
  }

  return [];
};
